export class Partner {
    id: string;
    base64: string;
    redirect_url: string;
    name: string;
    logo_height: number;
    logo_width: number;
    order: number;
}
